import {NgModule} from '@angular/core';
import {KeysPipe} from './keys.pipe';
import {Logo} from './logo.component';
import {FilterPipe} from './filter.pipe';
import {TogglesComponent} from './toggles.component';
import {CounterComponent} from './counter.component';
import {CharacterPicker} from './character.picker';
import {AbsPipe} from './abs.pipe';
import {HighlightPipe} from './highlight.pipe';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoggerModule, NgxLoggerLevel} from 'ngx-logger';
import {environment} from '../../environments/environment';
import {NewLinePipe} from './newline.pipe';
import {Logout} from './logout.component';
import {FileDropDirective} from './filedrop.directive';
import {CharacterChipComponent} from './character.chip';
import {AuthLibModule} from 'gamesis-auth';
import {VarDirective} from './var.directive';
import {UserInfoComponent} from './userInfo.component';
import {RegistrationCodeComponent} from './registrationcode.component';
import {DiceformulaComponent} from './diceformula.component';
import {TrimDirective} from './trim.directive';
import {SortPipe} from './sort.pipe';
import {FilesizePipe} from './filesize.pipe';
import {TimeFormatPipe} from './tomeformat.pipe';
import {CharacterAvatarComponent} from './character.avatar';
import {MenuToggleComponent} from './menu.button';
import {ContextMenuDirective} from './contextmenu.directive';
import {AddCardComponent} from './add.card';
import {AppLabelComponent} from './app.label';
import {InputComponent} from './input.component';
import {KeyboardScrollDirective} from './keyboard.directive';
import {InfoComponent} from './info.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AuthLibModule,
        LoggerModule.forRoot({
            level: environment.production ? NgxLoggerLevel.INFO : NgxLoggerLevel.DEBUG
        }),
        KeysPipe,
        FilterPipe,
        AbsPipe,
        HighlightPipe,
        NewLinePipe,
        Logo,
        FileDropDirective,
        VarDirective,
        UserInfoComponent,
        TrimDirective,
        SortPipe,
        FilesizePipe,
        TimeFormatPipe,
        ContextMenuDirective,
        AppLabelComponent,
        KeyboardScrollDirective,
        InfoComponent
    ],
    declarations: [
        TogglesComponent,
        Logout,
        CharacterPicker,
        CounterComponent,
        CharacterChipComponent,
        RegistrationCodeComponent,
        DiceformulaComponent,
        CharacterAvatarComponent,
        MenuToggleComponent,
        AddCardComponent,
        InputComponent
    ],
    exports: [
        KeysPipe,
        FilterPipe,
        NewLinePipe,
        AbsPipe,
        HighlightPipe,
        Logo,
        Logout,
        TogglesComponent,
        CharacterPicker,
        CounterComponent,
        FileDropDirective,
        CharacterChipComponent,
        VarDirective,
        UserInfoComponent,
        RegistrationCodeComponent,
        DiceformulaComponent,
        TrimDirective,
        SortPipe,
        FilesizePipe,
        TimeFormatPipe,
        CharacterAvatarComponent,
        MenuToggleComponent,
        ContextMenuDirective,
        AddCardComponent,
        AppLabelComponent,
        InputComponent,
        KeyboardScrollDirective,
        InfoComponent
    ]
})
export class SharedModule {
}
